import { defineStore } from 'pinia'
import { mergeOptionsParams, useCreateForm, useEditForm } from "@/stores/_helpers.js";
import toasteventbus from "primevue/toasteventbus";

export const useDeviceTypesStore = defineStore('deviceTypes', {
  state: () => ({
    data: undefined,
    options: undefined,
  }),
  getters: {
    getDeviceTypes: (state) => state.data?.data,
    getDeviceTypeOptions: (state) => state.options?.data,
  },
  actions: {
    /**
     * This method should be used to return as little data as possible for use in select boxes
     *
     * @param params
     * @param silent
     * @returns {Promise<any>}
     */
    async indexDeviceTypeOptions(params = {}, silent = true) {

      if (!silent)
        this.options = undefined;

      try {
        if (!this.options) {
          let qryParams = mergeOptionsParams(params, 'device_types', ['id', 'name', 'company_id']);
          const response = await axios.get('device-types', {params: qryParams});
          this.options = response.data;
        }

        return this.options;
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
    async indexDeviceTypes(params = {}) {
      try {
        const response = await axios.get('device-types', {params});
        this.data = response.data;
        return this.data;
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
    async createDeviceType(params = {}) {
      try {
        const response = await axios.get('device-types/create', {params});
        return useCreateForm('device-types', response.data, { onFinish: () => this.options = undefined });
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
    async showDeviceType(deviceTypeId, params = {}) {
      try {
        const response = await axios.get(`device-types/${ deviceTypeId }`, {params});
        return response.data;
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
    async editDeviceType(deviceTypeId, params = {}) {
      try {
        const response = await axios.get(`device-types/${ deviceTypeId }/edit`, {params});
        return useEditForm(`device-types/${ deviceTypeId }`, response.data, { onFinish: () => this.options = undefined });
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
    async deleteDeviceType(deviceTypeId, params = {}) {
      try {
        const response = await axios.delete(`device-types/${ deviceTypeId }`, {params});
        this.options = undefined;
        toasteventbus.emit('add', {
          summary: 'Device Type Deleted',
          detail: `Device Type has been deleted.`,
          severity: 'success',
          life: 3000
        });
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
  },
});
